import React from "react";
//import { landingSection2 } from "../../../api/testimonialsPage/section3";
import { FeaturedTestimonialProps } from "@/models/ITestimonial";

const FeaturedTestimonial = ({
  comment,
  headerBold,
  headerNormal,
}: FeaturedTestimonialProps) => {
  if (!comment) return null;

  return (
    <div className="border shadow-[4px_4px_0px_0px_#fbcfc8] bg-bg-neutral_rose_tint border-border-gray90 rounded-xl p-8 md:px-12">
      <div className="text-center mb-10">
        <div className="inline-block border border-none bg-bg-neutral_rose px-4 py-2">
          <h2 className="text-xl md:text-2xl leading-normal font-medium">
            {headerBold}
          </h2>
        </div>
      </div>

      <div className="relative grid md:grid-cols-2 grid-cols-1 gap-10">
        <div className="hidden md:block absolute left-1/2 top-0 h-full w-px bg-border-lilly_pink"></div>

        <p className="md:text-base leading-normal font-normal">
          {comment.Comment1}
        </p>

        {comment.Comment2 && comment.Comment2.trim() !== "" && (
          <p className="md:text-base leading-normal font-normal">
            {comment.Comment2}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-4 items-center justify-center mt-10">
        <div className="text-xl leading-normal font-semibold">
          {headerNormal}
        </div>
        <div className="flex items-center gap-4">
          {comment.Image?.url && (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${comment.Image.url}`}
              alt={comment.Image?.alternativeText || "Testimonial"}
              className="h-16 w-16 rounded-lg object-cover"
            />
          )}

          <div>
            <div className="text-base leading-normal font-semibold text-[#465158]">
              {comment.Name}
            </div>
            <div className="text-base leading-normal font-normal text-[#465158]">
              {comment.Designation}
              {/* {comment.BiotechName && ` at ${comment.BiotechName}`} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedTestimonial;
